import { Form, Formik } from 'formik'
import * as React from 'react'
import { ActivityFormActions } from './ActivityFormActions'
import { EditActivityStatusHeader } from './EditActivityStatusFormHeader'
import { useHandlers, useInitValues } from './hooks'
import { Activity, useActivityData } from '@user/features/Activity'
import { EditActivityStatusFormDetails } from './EditActivityStatusFormDetail/EditActivityStatusFormDetails'
import Stack from '@mui/material/Stack'
import { ActivityStatusSelect } from '../../ActivityStatusSelect'

export type Props = {
  activity: Activity
  onClose: () => void
  onSave?: (activity: Activity) => void
}

export function EditStatusActivityForm(props: Props) {
  const { activity, onClose } = props
  const { onSubmit } = useHandlers(props)
  const { updateDeleteEnabled } = useActivityData({ activity })
  const initValues = useInitValues(activity)

  return (
    <Formik initialValues={initValues} onSubmit={onSubmit}>
      <Form>
        <Stack width={338} padding={2}>
          <EditActivityStatusHeader title={activity.subject} />
          <EditActivityStatusFormDetails activity={activity} />
          {updateDeleteEnabled ? (
            <>
              <ActivityStatusSelect id={activity?.id || -1} />
              <ActivityFormActions onCancelClick={onClose} />
            </>
          ) : null}
        </Stack>
      </Form>
    </Formik>
  )
}
